import { useState } from "react";

export default function FeedbackModal({ onSubmit, onClose }) {
  const [comment, setComment] = useState("");

  const handleSubmit = () => {
    if (comment.trim()) onSubmit(comment);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>ხელახალი კლასიფიკაცია</h3>
        <p style={{ marginBottom: 12, color: "#64748b", fontSize: 14 }}>
          გთხოვთ, მიუთითეთ რატომ არის წერილი არასწორად გადანაწილებული.
        </p>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="მაგ: ეს არ არის საკრედიტო საკითხი, ეს მომხმარებელთა მომსახურების თემაა."
        />
        <div className="modal-buttons">
          <button className="cancel-btn" onClick={onClose}>გაუქმება</button>
          <button className="send-btn" onClick={handleSubmit} disabled={!comment.trim()}>
            გაგზავნა
          </button>
        </div>
      </div>
    </div>
  );
}
